import * as React from "react"
import { useOnboardingContext } from "src/frontend/components/Public/Onboarding/OnboardingContext"

export function useGoToSignInHome() {
  const { dispatch } = useOnboardingContext()
  return React.useCallback(() => {
    dispatch({ type: "SHOW_SIGN_IN" })
    dispatch({ type: "BACK" })
  }, [dispatch])
}
